import React, { useEffect, useState } from "react";
import { api, money, formatApiErrorDetail } from "../lib/api";

// Fetches USPS options for the given items + ZIP; calls onChange(option|null).
export const ShippingOptions = ({ items, zip, value, onChange, accent = "yellow" }) => {
  const [opts, setOpts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [nonce, setNonce] = useState(0);
  const zip5 = (zip || "").trim().slice(0, 5);
  const key = JSON.stringify(items);

  useEffect(() => {
    if (!/^\d{5}$/.test(zip5) || !items.length) {
      setOpts([]); setError(""); onChange(null);
      return;
    }
    let live = true;
    setLoading(true); setError("");
    const t = setTimeout(() => {
      api.post("/shipping/quote", { items, zip: zip5 })
        .then(({ data }) => {
          if (!live) return;
          setOpts(data.options);
          onChange(data.options.find((o) => o.service === value?.service) || data.options[0]);
        })
        .catch((e) => {
          if (!live) return;
          setOpts([]); onChange(null);
          setError(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't get a shipping price.");
        })
        .finally(() => live && setLoading(false));
    }, 400);
    return () => { live = false; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zip5, key, nonce]);

  const ring = accent === "green" ? "border-emerald-400 bg-emerald-400/10" : "border-yellow-400 bg-yellow-400/10";
  if (!/^\d{5}$/.test(zip5)) return <p data-testid="shipping-enter-zip" className="text-sm text-zinc-500">Enter a 5-digit ZIP to see shipping options.</p>;
  if (loading) return <p data-testid="shipping-loading" className="text-sm text-zinc-400 font-mono">Getting USPS rates…</p>;
  if (error) {
    return (
      <div data-testid="shipping-error" className="text-sm text-red-400">
        {error}
        <button data-testid="shipping-retry" onClick={() => setNonce((n) => n + 1)} className="ml-2 underline text-white">Try again</button>
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid="shipping-options">
      {opts.map((o) => (
        <button
          key={o.service}
          type="button"
          data-testid={`shipping-option-${o.service.toLowerCase()}`}
          onClick={() => onChange(o)}
          className={`w-full flex justify-between items-center text-left px-4 py-3 rounded-md border transition-colors ${value?.service === o.service ? ring : "border-white/15 hover:border-white/30"}`}
        >
          <span><span className="block text-white text-sm font-semibold">{o.label}</span><span className="block text-xs text-zinc-500">{o.eta}{o.packages > 1 ? ` · ${o.packages} boxes` : ""}</span></span>
          <span className="font-mono text-white">{money(o.price)}</span>
        </button>
      ))}
    </div>
  );
};
